import { Route, Routes } from "react-router-dom";
import React, { useEffect } from "react";

import "./main.scss";
import Aos from "aos";

import { useDispatch } from "react-redux";
import { fetchAllData } from "./redux/slices/mainDataSlice";
import Home from "./pages/client/home/Home";
import Social from "./pages/client/social/Social";
import Services from "./pages/client/services/Services";
import Cases from "./pages/client/cases/Cases";
import Home1 from "./pages/admin/home/Home";
import Social1 from "./pages/admin/social/Social";
import Services1 from "./pages/admin/services/Services";
import Cases1 from "./pages/admin/cases/Cases";
import Header from "./components/client/header/Header";
import Footer from "./components/client/footer/Footer";
import Login from "./pages/login/Login";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  useEffect(() => {
    Aos.init();
  }, []);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAllData());
  }, []);
  return (
    <>
      <Header />
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/social" element={<Social />} />
        <Route path="/services" element={<Services />} />
        <Route path="/cases" element={<Cases />} />

        <Route path="/admin/" element={<Home1 />} />
        <Route path="/admin/social" element={<Social1 />} />
        <Route path="/admin/services" element={<Services1 />} />
        <Route path="/admin/cases" element={<Cases1 />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
